import { RotateCcw } from "lucide-react";
import { IdeaCard } from "@/components/IdeaCard";
import { StreamConsole } from "@/components/StreamConsole";

export const GeneratorResults = ({ loading, streamText, ideas, onRegenerate }) => (
  <section className="mt-16" data-testid="generator-results">
    {loading && <StreamConsole text={streamText} />}
    {!loading && ideas.length > 0 && (
      <>
        <div className="flex items-end justify-between gap-4 mb-6">
          <div>
            <div className="overline-label">Risultati</div>
            <h2 className="font-display text-2xl font-bold mt-2">Le tue 3 idee</h2>
          </div>
          <button onClick={onRegenerate} data-testid="btn-regenerate" className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-amber-300 transition-colors">
            <RotateCcw className="w-4 h-4" /> Rigenera
          </button>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {ideas.map((idea, i) => <IdeaCard key={idea.id} idea={idea} index={i} testId={`idea-card-${i + 1}`} />)}
        </div>
      </>
    )}
  </section>
);
